'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TemplateContainer = function (_React$Component) {
  (0, _inherits3.default)(TemplateContainer, _React$Component);

  function TemplateContainer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TemplateContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TemplateContainer.__proto__ || (0, _getPrototypeOf2.default)(TemplateContainer)).call.apply(_ref, [this].concat(args))), _this), _this._templateSetter = function (cmp) {
      _this._template = cmp;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TemplateContainer, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props.anySelected !== nextProps.anySelected || this.props.itemSelected !== nextProps.itemSelected || this.props.item !== nextProps.item || this.props.template !== nextProps.template || this.props.commonProps !== nextProps.commonProps;
    }
  }, {
    key: 'getTemplate',
    value: function getTemplate() {
      return this._template;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          item = _props.item,
          itemSelected = _props.itemSelected,
          anySelected = _props.anySelected,
          dragHandle = _props.dragHandle,
          commonProps = _props.commonProps;

      var Template = this.props.template;

      return _react2.default.createElement(Template, {
        ref: this._templateSetter,
        item: item,
        itemSelected: itemSelected,
        anySelected: anySelected,
        dragHandle: dragHandle,
        commonProps: commonProps
      });
    }
  }]);
  return TemplateContainer;
}(_react2.default.Component);

TemplateContainer.propTypes = {
  item: _propTypes2.default.object.isRequired,
  template: _propTypes2.default.func.isRequired,
  itemSelected: _propTypes2.default.number.isRequired,
  anySelected: _propTypes2.default.number.isRequired,
  dragHandle: _propTypes2.default.func.isRequired,
  commonProps: _propTypes2.default.object
};
exports.default = TemplateContainer;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/react-draggable-list/js/TemplateContainer.js
// module id = 1008
// module chunks = 0